import React, {useContext, useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import axios from "axios";
import "../../assets/stylesheets/about.css";
import whatsappIcon from "../../assets/image/whatsapp.svg";
import viberIcon from "../../assets/image/viber.svg";
import telegramIcon from "../../assets/image/telegram.svg";
import phoneIcon from "../../assets/image/phone.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/lazy";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Lazy, Pagination, Navigation } from "swiper";
import {ContactInfoContext} from "../additional/ContactInfoContext";

function AboutUs() {
    const { t, i18n } = useTranslation(["about", "error"]);
    const [people, setPeople] = useState([]);
    const { contactInfo } = useContext(ContactInfoContext);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_MY_API_KAY}/contact/persons`, {
                params: { language: i18n.language || "hy" },
            })
            .then((res) => {
                const sortedPeople = res.data.sort((a, b) =>
                    b.director ? 1 : 0 - (a.director ? 1 : 0)
                );
                setPeople(sortedPeople);
            })
            .catch((error) => {
                console.error("Error fetching persons data:", error);
                setPeople([]);
            });
    }, [i18n.language]);

    return (
        <>
            <Helmet>
                <link
                    rel="canonical"
                    href={`https://sievn.am/${i18n.language}/${t(
                        "aboutUs"
                    )}`}
                />
                <meta
                    property="og:url"
                    content={`https://sievn.am/${i18n.language}/${t(
                        "aboutUs"
                    )}`}
                />
                <meta property="og:title" content={t("aboutTitle")} />
                <meta property="og:site_name" content="sievn.am" />
                <meta property="og:description" content={t("aboutDescription")} />
                <meta property="og:image" content={`${process.env.REACT_APP_MY_API_KAY}/s3/headers/about-us.webp`} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta name="description" content={t("aboutDescription")} />
                <title>{t("aboutTitle")}</title>
            </Helmet>
            <section className="about-page-about">
                <div className="header-about">
                    <img src={contactInfo.aboutUsUrl} alt="About Us Header" />
                </div>
                <div className="main-container-about wrapper-about">
                    <div className="content-about">
                        <div className="info-about">

                            <div className="title-about">
                                <h1>
                                    <em>{t("about")}</em>
                                </h1>
                            </div>

                            <p className="text-about">{t("aboutInfo")}</p>
                        </div>
                        <div className="team-about">
                            {people.length > 0 ? (
                                <div className="person-grid-about">
                                    {people.map((person, index) => (
                                        <div className="person-about" key={index}>
                                            <div className="person-card-about">
                                                <img
                                                    className="person-image-about"
                                                    src={`data:image/jpeg;base64,${person.image}`}
                                                    alt={person.name}
                                                />
                                                <div className="person-details-about">
                                                    <p className="name-about">{person.name}</p>
                                                    <p className="role-about">
                                                        {person.director ? t("director") : ""}
                                                    </p>
                                                    <p className="description-about">
                                                        {person.description || t("specialistContact")}
                                                    </p>
                                                    {/*<div className="social-about">*/}
                                                    {/*    {person.wpPhone && (*/}
                                                    {/*        <a*/}
                                                    {/*            target="_blank"*/}
                                                    {/*            href={`https://api.whatsapp.com/send?phone=${person.wpPhone}`}*/}
                                                    {/*            className="social-item-about"*/}
                                                    {/*            rel="noopener noreferrer"*/}
                                                    {/*        >*/}
                                                    {/*            <img src={whatsappIcon} alt="WhatsApp" />*/}
                                                    {/*        </a>*/}
                                                    {/*    )}*/}
                                                    {/*    {person.telPhone && (*/}
                                                    {/*        <a*/}
                                                    {/*            target="_blank"*/}
                                                    {/*            href={`tel:${person.telPhone}`}*/}
                                                    {/*            className="social-item-about"*/}
                                                    {/*            rel="noopener noreferrer"*/}
                                                    {/*        >*/}
                                                    {/*            <img src={phoneIcon} alt="Phone" />*/}
                                                    {/*        </a>*/}
                                                    {/*    )}*/}
                                                    {/*    {person.viberPhone && (*/}
                                                    {/*        <a*/}
                                                    {/*            target="_blank"*/}
                                                    {/*            href={`https://msng.link/o/?${person.viberPhone}=vi`}*/}
                                                    {/*            className="social-item-about"*/}
                                                    {/*            rel="noopener noreferrer"*/}
                                                    {/*        >*/}
                                                    {/*            <img src={viberIcon} alt="Viber" />*/}
                                                    {/*        </a>*/}
                                                    {/*    )}*/}
                                                    {/*    {person.tgUsername && (*/}
                                                    {/*        <a*/}
                                                    {/*            target="_blank"*/}
                                                    {/*            href={`https://t.me/${*/}
                                                    {/*                person.tgUsername.startsWith("@")*/}
                                                    {/*                    ? person.tgUsername.slice(1)*/}
                                                    {/*                    : person.tgUsername*/}
                                                    {/*            }`}*/}
                                                    {/*            className="social-item-about"*/}
                                                    {/*            rel="noopener noreferrer"*/}
                                                    {/*        >*/}
                                                    {/*            <img src={telegramIcon} alt="Telegram" />*/}
                                                    {/*        </a>*/}
                                                    {/*    )}*/}
                                                    {/*</div>*/}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="fallback-about">
                                    {t("noEmployeesAvailable", { ns: "error" })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {people.length > 0 && (
                    <Swiper
                        style={{
                            "--swiper-navigation-color": "#fff",
                            "--swiper-pagination-color": "#fff",
                        }}
                        lazy={true}
                        pagination={{ clickable: true }}
                        navigation={true}
                        modules={[Lazy, Pagination, Navigation]}
                        className="about-swiper-about"
                    >
                        {people.map((person, index) => (
                            <SwiperSlide key={index}>
                                <div className="person-card-about">
                                    <img
                                        className="person-image-about"
                                        src={`data:image/jpeg;base64,${person.image}`}
                                        alt={person.name}
                                    />
                                    <div className="person-details-about">
                                        <p className="name-about">{person.name}</p>
                                        <p className="role-about">
                                            {person.director ? t("director") : ""}
                                        </p>
                                        <p className="description-about">
                                            {person.description || t("specialistContact")}
                                        </p>
                                        {/*<div className="social-about">*/}
                                        {/*    {person.wpPhone && (*/}
                                        {/*        <a*/}
                                        {/*            target="_blank"*/}
                                        {/*            href={`https://api.whatsapp.com/send?phone=${person.wpPhone}`}*/}
                                        {/*            className="social-item-about"*/}
                                        {/*            rel="noopener noreferrer"*/}
                                        {/*        >*/}
                                        {/*            <img src={whatsappIcon} alt="WhatsApp" />*/}
                                        {/*        </a>*/}
                                        {/*    )}*/}
                                        {/*    {person.telPhone && (*/}
                                        {/*        <a*/}
                                        {/*            target="_blank"*/}
                                        {/*            href={`tel:${person.telPhone}`}*/}
                                        {/*            className="social-item-about"*/}
                                        {/*            rel INSTRUP*/}
                                        {/*        >*/}
                                        {/*            <img src={phoneIcon} alt="Phone" />*/}
                                        {/*        </a>*/}
                                        {/*    )}*/}
                                        {/*    {person.viberPhone && (*/}
                                        {/*        <a*/}
                                        {/*            target="_blank"*/}
                                        {/*            href={`https://msng.link/o/?${person.viberPhone}=vi`}*/}
                                        {/*            className="social-item-about"*/}
                                        {/*            rel="noopener noreferrer"*/}
                                        {/*        >*/}
                                        {/*            <img src={viberIcon} alt="Viber" />*/}
                                        {/*        </a>*/}
                                        {/*    )}*/}
                                        {/*    {person.tgUsername && (*/}
                                        {/*        <a*/}
                                        {/*            target="_blank"*/}
                                        {/*            href={`https://t.me/${*/}
                                        {/*                person.tgUsername.startsWith("@")*/}
                                        {/*                    ? person.tgUsername.slice(1)*/}
                                        {/*                    : person.tgUsername*/}
                                        {/*            }`}*/}
                                        {/*            className="social-item-about"*/}
                                        {/*            rel="noopener noreferrer"*/}
                                        {/*        >*/}
                                        {/*            <img src={telegramIcon} alt="Telegram" />*/}
                                        {/*        </a>*/}
                                        {/*    )}*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
            </section>
        </>
    );
}

export default AboutUs;